/**
 * Returns true if __debug_mode is set to true in localStorage.
 */
const isDebugMode = () => {
  const debugMode = localStorage.getItem('__debug_mode');
  return debugMode === 'true' || debugMode === '1' || debugMode === 't';
};

/**
 * Log message in the console if debug mode is on.
 */
export const log = (message: any, ...args: unknown[]) => {
  if (!isDebugMode()) return;
  window.console.log(message, ...args);
};
